import startCase from 'lodash/startCase'
import {
  ADMIN,
  ADVISER,
  INDIVIDUAL,
  isAdminAccount,
  isIndividualAccount,
  isLawyerAccount,
  isStandardAccount,
  LAWYER,
  SINGLE_USER,
  STANDARD_BUSINESS
} from '../dataAccess/accountTypes'

const progressStages = [
  ['Created', 2],
  ['Ready', 2],
  ['Counterparty', 2],
  ['Negotiation', 2],
  ['Signature', 2]
]
const stageOrder = progressStages.map(([name]) => name.toLowerCase())

function finaliseStages(stages) {
  const totalWidth = stages.reduce((acc, [_name, width]) => acc + width, 0)

  return stages.reduce(
    (acc, [name, width], index) =>
      acc.concat({
        name: name,
        width: width / totalWidth,
        Name: startCase(name),
        order: index
      }),
    []
  )
}

export const getCurrentStage = (doc) => {
  const stageLCase = doc.stage.toLowerCase()
  const index = stageOrder.findIndex((stage) => stage === stageLCase) || 0
  return [stageLCase, index]
}

export const getDocProgressStages = () => finaliseStages(progressStages)

// #region withoutNegotiation
export const getCurrentStageWithoutNegotiation = (doc, includesLawyer) => {
  if (isIndividualAccount(doc.accountType)) {
    return ['client', 0]
  }
  if (isAdminAccount(doc.accountType)) {
    return ['client', 0]
  } // TODO ALPHA remove when New Doc fixed
  const stageLCase = doc.stage.toLowerCase()
  if (stageLCase === 'created') {
    return [doc.accountType, 0]
  }
  if (stageLCase === 'client completed') {
    return [doc.accountType, 2]
  }
  // if (stageLCase === 'lawyer' && doc.status === 'Generated') { return [doc.accountType, 2] }
  if (stageLCase === 'lawyer' && isLawyerAccount(doc.accountType)) {
    return ['lawyer', 2]
  }
  if (stageLCase.includes(doc.accountType)) {
    return [doc.accountType, 0]
  }
  if (stageLCase === 'admin') {
    return [doc.accountType, 0]
  } // TODO ALPHA remove when New Doc fixed
  if (stageLCase.includes('client')) {
    return ['client', 1]
  }
  if (stageLCase.includes('lawyer') && !isStandardAccount(doc.accountType)) {
    return ['lawyer', 3]
  }
  if (
    stageLCase.includes('lawyer') &&
    includesLawyer &&
    isStandardAccount(doc.accountType)
  ) {
    return ['lawyer', 2]
  }
  if (stageLCase.includes('ready') && isStandardAccount(doc.accountType)) {
    return ['ready', 1]
  }
  if (
    stageLCase.includes('counterparty') &&
    isStandardAccount(doc.accountType)
  ) {
    if (includesLawyer) {
      return ['counterparty', 3]
    } else {
      return ['counterparty', 2]
    }
  }
  if (stageLCase.includes('signature') && isStandardAccount(doc.accountType)) {
    if (includesLawyer) {
      return ['signature', 4]
    } else {
      return ['signature', 3]
    }
  }
  return [stageLCase, 1]
}

const progressStagesWithoutNegotiationConfig = [
  {
    type: INDIVIDUAL.id,
    stages: [['', 1]]
  },
  {
    type: ADVISER.id,
    stages: [
      ['adviser', 2],
      ['client', 3],
      ['adviser', 1],
      ['lawyer', 2]
    ]
  },
  {
    type: LAWYER.id,
    stages: [
      ['lawyer', 2],
      ['client', 3],
      ['lawyer', 2]
    ]
  },
  {
    type: SINGLE_USER.id,
    stages: [
      ['Created', 2],
      ['Ready', 2],
      ['Lawyer', 2],
      ['Counterparty', 2],
      ['Signature', 2]
    ]
  },
  {
    type: STANDARD_BUSINESS.id,
    stages: [
      ['Created', 2],
      ['Ready', 2],
      ['Lawyer', 2],
      ['Counterparty', 2],
      ['Signature', 2]
    ]
  },
  {
    type: ADMIN.id,
    stages: [['', 1]]
  }
]

const progressStagesWithoutNegotiation =
  progressStagesWithoutNegotiationConfig.reduce((acc, typeStagesObj) => {
    acc[typeStagesObj.type] = finaliseStages(typeStagesObj.stages)
    return acc
  }, {})

export const getDocProgressStagesWithoutNegotiation = (doc) => {
  const includesLawyer = 'lawyer' in (doc.roles || {})
  const docProgressStages = progressStagesWithoutNegotiation[doc.accountType]
  if (!includesLawyer && isStandardAccount(doc.accountType)) {
    return docProgressStages
      .filter((stage) => stage.name !== 'Lawyer')
      .map((stage, idx) => ({ ...stage, order: idx }))
  }
  return docProgressStages
}
// #endregion withoutNegotiation
